var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"base"}},[_c('Particles',{attrs:{"id":"space","options":{
          background: {
              color: {
                  value: '#000'
              }
          },
          fpsLimit: 60,
          particles: {
              color: {
                  value: 'random'
              },
              move: {
                  direction: 'none',
                  enable: true,
                  outMode: 'out',
                  random: true,
                  speed: 3.223,
                  straight: true
              },
              number: {
                  density: {
                      enable: true,
                      value_area: 200
                  },
                  value: 50
              },
              opacity: {
                  value: 'random'
              },
              shape: {
                  image: {
                    height: 300,
                    width: 300,
                    replace_color: true,
                    src: require('@/assets/bdk.png')
                  },
                  type: 'image'
              },
              size: {
                  random: true,
                  value: 5
              },
              trail: {
                  enable: true
              }
          },
          detectRetina: true
      }}}),_c('h1',{staticClass:"mctext",staticStyle:{"font-size":"3em","font-weight":"bold","margin-bottom":"0"}},[_vm._v("Bedrockk")]),_c('p',{staticClass:"mctext"},[_vm._v("bedrock like rock")]),_c('div',{attrs:{"id":"scene"}}),_c('p',{staticClass:"mctext",staticStyle:{"margin-bottom":"30px","font-size":"1.5em"}},[_vm._v("Projects")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }